import { action } from "mobx";
import NiaRepository from "../../repositories/niaRepository";
import EshopError from "../../models/eshopError";
import EventBus, { NIARedirectFailure } from "../eventBus";
import { persistCallbackDestination } from "utils/externalServiceUtils";

export const NIA_REDIRECT_FAILURE = "NIA_REDIRECT_FAILURE";

export enum Notice {
  EXEMPTION = "exemption",
  OMISSION = "omission",
  LICENSE_PLATE_CHANGE = "license_plate_change",
  REFUND_REQUEST = "refund_request",
}

export const SESSION_STORAGE_NIA_REQUEST_SOURCE_KEY = "NIA_REQUEST_SOURCE";
const NIA_CALLBACK_DESTINATION_PATH = "nia";

export default class NiaService {
  constructor(private repository: NiaRepository, private eventBus: EventBus) {}

  @action
  redirectToNia(notice: Notice) {
    this.repository
      .niaRedirect()
      .then(response => {
        if (response instanceof EshopError) {
          this.eventBus.publish(NIARedirectFailure({ type: response.type }));
        } else {
          persistCallbackDestination(NIA_CALLBACK_DESTINATION_PATH);
          sessionStorage.setItem(SESSION_STORAGE_NIA_REQUEST_SOURCE_KEY, notice);
          window.location.href = response.redirectUrl;
        }
      })
      .catch(() => {
        this.eventBus.publish(NIARedirectFailure({ type: NIA_REDIRECT_FAILURE }));
      });
  }
}
